import { render, staticRenderFns } from "./roofing-home.vue?vue&type=template&id=afeac02a&scoped=true&"
import script from "./roofing-home.vue?vue&type=script&lang=js&"
export * from "./roofing-home.vue?vue&type=script&lang=js&"
import style0 from "./roofing-home.vue?vue&type=style&index=0&id=afeac02a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeac02a",
  null
  
)

export default component.exports